<script>
import { mapGetters } from "vuex";

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
export default {
  components: { VueSlider },
  props: {
    moneda: { type: String, required: true }
  },
  data() {
    return {
      value: [
        this.$store.getters.getFiltroPrecioMin(this.moneda),
        this.$store.getters.getFiltroPrecioMax(this.moneda)
      ],
      formatter: v => `$${("" + v).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`
    };
  },
  watch: {
    value(value) {
      this.$store.commit("setFiltroPrecio", {
        moneda: this.moneda,
        montos: value
      });
    }
  },
  computed: {
    ...mapGetters(["isPreloader", "getFiltroPrecioMin", "getFiltroPrecioMax"]),
    precioMin() {
      return this.value[0].toLocaleString("en-US", {
        style: "currency",
        currency: "USD"
      });
    },
    precioMax() {
      return this.value[1].toLocaleString("en-US", {
        style: "currency",
        currency: "USD"
      });
    }
  },
  methods: {
    clear() {
      if (
        this.value[0] > this.getFiltroPrecioMin(this.moneda) ||
        this.value[1] < this.getFiltroPrecioMax(this.moneda)
      ) {
        this.value = [
          this.getFiltroPrecioMin(this.moneda),
          this.getFiltroPrecioMax(this.moneda)
        ];
      }
    }
  }
};
</script>

<template>
  <div class="panel-body">
    <div class="rangos">
      <small v-text="moneda"></small>
      <span v-text="precioMin"></span> -
      <small v-text="moneda"></small>
      <span v-text="precioMax"></span>
    </div>
    <vue-slider
      v-model="value"
      :min="getFiltroPrecioMin(moneda)"
      :max="getFiltroPrecioMax(moneda)"
      :tooltip-formatter="formatter"
    ></vue-slider>
  </div>
</template>

<style scoped>
.rangos {
  text-align: center;
  font-weight: 500;
  margin-bottom: 10px;
  font-size: 14px;
  color: #ccd1d9;
}
.rangos > small {
  font-size: 12px;
  color: #aab2bd;
}
.rangos > span {
  color: #656d78;
}
</style>